import { all, call, put, takeLatest, select } from "redux-saga/effects";

import actions from "../../constants/actions";
import { GET } from "../../utils/api";
import { getLocale } from "../selectors/app";

export function* getTeam({ payload }) {
    const locale = yield select(getLocale);

    try {
        let response = yield call(GET, {
            url: "api/team/",
            locale,
        });

        yield put({
            type: actions.TEAM.LOAD_SUCCESS,
            payload: response,
        });
    } catch (error) {
        yield put({ type: actions.TEAM.LOAD_FAIL, payload: error });
    }
}

export default function* Team() {
    yield all([yield takeLatest(actions.TEAM.LOAD, getTeam)]);
}
